import React from 'react';

export default function PencilIcon({className}) {
	return (
        <svg className={className ? className : ''} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.4 12.3" preserveAspectRatio="xMidYMid meet"><path d="M12.3 3L9.5.2c-.2-.2-.6-.2-.8 0L.5 8.3l-.1.2-.4 3v.1c0 .4.3.7.7.7h.1l2.9-.3h.2l8.3-8.3c.1-.1.2-.3.2-.4l-.1-.3zM1.6 8.6L8 2.3l2.1 2.1-6.3 6.3-2.2-2.1zm-.4 1.1l1.4 1.4-1.6.2.2-1.6zm9.6-6L8.7 1.6l.4-.4 2.1 2.1-.4.4z"/></svg>
	);
}
